import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListMataPelajaran } from "@/services/getData"

export default function SyncMataPelajaranPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listMataPelajaran"],
    queryFn: getListMataPelajaran,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
